function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState, createContext, useReducer, useContext, useRef } from 'react';
import kebab from '../utils/kebab';
import uuid from '../utils/uuid';
import minifyCss from '../utils/minifyCss';
import noop from '../utils/noop';
import { createPortal } from 'react-dom';
var MockContext = {
  ids: {},
  dispatch: noop,
  isMock: true
};
var StyleContext = createContext(MockContext);
function reducer(state, action) {
  var id = action.payload.id;
  switch (action.type) {
    case 'add':
      var idExists = state[id];
      return _objectSpread({}, state, _defineProperty({}, id, idExists ? idExists.concat(action.payload.ref).filter(function (val, i, src) {
        return src.indexOf(val) === i;
      }) : [action.payload.ref]));
    case 'remove':
      if (state[id].length > 1) {
        return _objectSpread({}, state, _defineProperty({}, id, state[id].filter(function (ref) {
          return ref !== action.payload.ref;
        })));
      } else {
        var x = state[id],
          rest = _objectWithoutProperties(state, [id].map(_toPropertyKey));
        return rest;
      }
  }
}
export function StyleContextProvider(_ref) {
  var children = _ref.children;
  var _useReducer = useReducer(reducer, {}),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    ids = _useReducer2[0],
    dispatch = _useReducer2[1];
  return /*#__PURE__*/React.createElement(StyleContext.Provider, {
    value: {
      ids: ids,
      dispatch: dispatch
    }
  }, children);
}
export default function Style(_ref2) {
  var id = _ref2.id,
    children = _ref2.children;
  var _useState = useState("style-".concat(uuid())),
    _useState2 = _slicedToArray(_useState, 1),
    uniqueId = _useState2[0];
  var ref = useRef(null);
  var _useContext = useContext(StyleContext),
    ids = _useContext.ids,
    dispatch = _useContext.dispatch,
    isMock = _useContext.isMock;
  var _useState3 = useState(isMock),
    _useState4 = _slicedToArray(_useState3, 2),
    outsideContextRender = _useState4[0],
    setRender = _useState4[1];
  var normalizedId = kebab(id);
  var inContextRender = ids[normalizedId] && ids[normalizedId][0] === uniqueId;
  useEffect(function () {
    var style = ref.current;
    if (isMock && style) {
      var styles = Array.from(document.querySelectorAll("[data-style-id=".concat(normalizedId, "]")));
      setRender(styles[0] === style);
    } else {
      dispatch({
        type: 'add',
        payload: {
          id: normalizedId,
          ref: uniqueId
        }
      });
    }
    return function () {
      if (!isMock) {
        dispatch({
          type: 'remove',
          payload: {
            id: normalizedId,
            ref: uniqueId
          }
        });
      }
    };
  }, [dispatch, isMock, normalizedId, uniqueId]);
  if (inContextRender || outsideContextRender) {
    return createPortal(/*#__PURE__*/React.createElement("style", {
      ref: ref,
      "data-style-id": normalizedId
    }, minifyCss(children)), document.head);
  } else {
    return null;
  }
}